import { LicensesApi, useAPIQuery } from "melco-shared-logic";

export const useLicense = (licenseId: string | undefined) => {
  //const token = useUserToken();
  //const baseApiConfig = useBaseAPIConfig();

  // const api = new LicensesApi(
  //   baseApiConfig({ token })
  // );

  return useAPIQuery(LicensesApi, ["license", licenseId], async (api) => {
    if (licenseId == null) {
      return;
    }

    return api.getBySerialNumber({ serialNumber: licenseId });
  });
};
